export type RoomList = string[];

export interface StringArray {
    [value: string]: string;
}

export interface Reconstruction {
    type: string;
    year: number;
    extent: string;
    description: string | null;
}

type Dimensions = Array<[number, number] | number>;

export class Room {
    public readonly type: string;

    public readonly isAddition: boolean;

    public readonly dimensions: Dimensions;

    constructor(type: string, isAddition: boolean, dimensions: Dimensions) {
        this.type = type;
        this.isAddition = isAddition;
        this.dimensions = dimensions;
    }
}

export interface BuildingPart {
    name: string;
    rooms: Room[];
}

export type EnumOption = string;
export interface EnumOptionWithCustomValue { option: EnumOption; customValue: string; }

export type EnumControlValue = EnumOption | EnumOptionWithCustomValue;

export interface Location {
    id: string;
    name: string;
}

export interface ChoiceOption {
    value: string;
    label: string;
    icon: string;
}

export interface AccessLand {
    prefixNumber: number;
    suffixNumber: number | null;
    landType: string;
    description: string | null;
}

export interface Parcel {
    number: string;
    note: string | null;
}
